import React, { useState } from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { generateId, shortHandDateTime } from '../../../utility/functions';
import Table from '../../../table/Table';
import LinkTo from '../../../forms/LinkTo';

const PromoCode = ({ ...props }) => {

    const [deals, setDeals] = useState([])

    const tableConfig = {
        getData: QuestRoute.reports.mobile.promoCode,
        reportCallback: (data, setDate) => {
            setDate(data.gridModelList);
            setDeals(data.promoCodeList)
        },
        headers: [
            {
                label: 'Name',
                propKey: 'name',
            }, {
                label: 'Email',
                propKey: 'email',
            }, {
                label: 'Deal Name',
                propKey: 'dealName',
                options: () => deals.map(e => e.label)
            }, {
                label: 'Code',
                propKey: 'code',
            }, {
                label: 'Code Name',
                propKey: 'codeName',
                options: true
            }, {
                label: 'Claimed',
                propKey: 'claimedDateTime',
                type: 'dateTime'
            }, {
                label: 'Redeemed',
                propKey: 'redeemedDateTime',
                type: 'dateTime'
            },
        ],
        sticker: [
            {
                label: 'Claimed Deals',
                color: '#3479b9',
                callback: (data) => data.length
            }, {
                label: 'Redeemed Deals',
                color: '#5a53c9',
                callback: (data) => data.reduce((a, b) => (b.redeemedDate ? 1 : 0) + a, 0)
            }
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>
                    <LinkTo customerId={e.userId}>{e.name}</LinkTo>
                </td>
                <td>{e.email}</td>
                <td>{e.dealName}</td>
                <td>{e.code}</td>
                <td>{e.codeName}</td>
                <td>{shortHandDateTime(e.claimedDateTime)}</td>
                <td>{e.redeemedDateTime ? shortHandDateTime(e.redeemedDateTime) : '-'}</td>
            </tr>
        )
    }

    return (
        <Table config={tableConfig} />
    );
}

export default PromoCode;